import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import groupBy from "lodash/groupBy";

export default class PromoWebContentController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.request = options;

    $ctrl.title = options.title || `Promotion Web Content...`;
    $ctrl.bus = new ServiceBus();
    // $ctrl.bus
    //   .read("QueryPromoSheets.json", { orderBy: "GroupName,Name" })
    //   .then(
    //     res => ($ctrl.promosheets = groupBy(res.data.results, "groupName"))
    //   );
  }

  $onInit() {
    const $ctrl = this;

  }

  upload($files) {
    let $ctrl = this;
    if ($files && $files.length) {
      let req = {
        request: {
          realm: "Promotion",
          tags: {
            PromoCode: $ctrl.request.id,
          },
        },
        files: $files,
        urls: [],
      };

      $ctrl.bus.upload("CreateMedia.json", req).then(function (response) {
        $ctrl.request.imageUrl = response.data.media[0].url;
      });
    }
  }

  submit() {
    const $ctrl = this;

    $ctrl.bus
      .send(`SavePromoWebContent.json`, $ctrl.request)
      .then(r => $ctrl.$close(r.data));
  }
}
